import { useAuth } from '@shared/common/providers/AuthProvider';

import type { AdjacentRound } from '../../../../../../../model/AdjacentRound/adjacentRound';
import { PredictionDirection } from '../../../../../../../model/PredictionDirection';
import { PredictionOption } from '../../PredictionOption/PredictionOption';
import { calculatePredictionOptionState } from './predictionOptionState';

type PredictionOptionsProps = {
  round: AdjacentRound;
};

const directions = [PredictionDirection.UP, PredictionDirection.DOWN];

export const PredictionOptions = ({ round }: PredictionOptionsProps) => {
  const { userEvmWallet } = useAuth();

  const optionsState = calculatePredictionOptionState({
    round,
    wallet: userEvmWallet?.attributes.address,
  });
  return (
    <div className="flex gap-2">
      {directions.map((direction) => (
        <PredictionOption
          key={direction}
          direction={direction}
          value={
            direction === PredictionDirection.UP
              ? round.bullAmount.formatted
              : round.bearAmount.formatted
          }
          state={optionsState[direction]}
        />
      ))}
    </div>
  );
};
